export default {
  ERROR: "ERROR",
};
